import Vue from 'vue'
import Router from 'vue-router'
import AppContent from '@/layout/Content'

import Client from '@/pages/clients/Client'
import ClientLocator from '@/pages/clients/Locator'

import Company from '@/pages/company/Company'
import CompanyList from '@/pages/company/List'
import CompanyTracking from '@/pages/company/Tracking'

Vue.use(Router)
const routesWithPrefix = (prefix, routes) => {
  return routes.map(route => {
    route.path = `${prefix}${route.path}`
    return route
  })
}

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      redirect: { name: 'Client' },
      component: AppContent,
      children: [
        ...routesWithPrefix('/clients', [
          {
            path: '/',
            name: 'Client',
            component: Client
          },
          {
            path: '/locator',
            name: 'ClientLocator',
            component: ClientLocator
          }
        ]),
        ...routesWithPrefix('/correos', [
          {
            path: '/',
            name: 'Company',
            component: Company
          },
          {
            path: '/list',
            name: 'CompanyList',
            component: CompanyList
          },
          {
            path: '/locator',
            name: 'CompanyTracking',
            component: CompanyTracking
          }
        ])
      ]
    }
  ],
  linkExactActiveClass: 'active'
})



// WEBPACK FOOTER //
// ./src/router/index.js